module.exports = __webpack_public_path__ + "img/indeximg3.ba414686.png";